// extracted by mini-css-extract-plugin
export default {"touch_component":"PreviewVideoFileComponent_touch_component__qvz+p"};